import React, {useState} from 'react';
import {VStack} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import ProfileItem from './Item';
import ProfileTitle from './Title';
import InternalTemplate from '../../../../components/templates/internal';
import {StackParamList} from '../../../../navigators';
import {useContextState} from '../../../../context/user';
import {DangerButton} from '../../../../components/buttons';
import {ResultState} from '../../../../constants/enumerations';
import {SpinnerModal} from '../../../../components/modals';
import useToast from '../../../../hooks';

type ScreenProps = NativeStackScreenProps<StackParamList, 'Profile'>;

const ProfileScreen = ({navigation}: ScreenProps) => {
  const {profile, removeAccount, getDashboardScreenName} = useContextState();
  const [isLoading, setIsLoading] = useState(false);
  const sleep = (ms: number) => new Promise((r: any) => setTimeout(r, ms));
  const {showServerError} = useToast();

  const handleGoBack = () => {
    const screenName = getDashboardScreenName();
    navigation.navigate(screenName);
  };

  const handleRemoveAccount = async () => {
    sleep(2000);
    setIsLoading(true);
    const result: ResultState = await removeAccount();
    setIsLoading(false);
    if (result === ResultState.success) {
      navigation.navigate('RemoveSuccess');
    } else {
      showServerError();
    }
  };

  if (profile == null) {
    return <></>;
  }

  return (
    <InternalTemplate
      title={'screen-profile-title'}
      backButton={{
        onPress: () => handleGoBack(),
        label: 'back-dashboard',
        usage: 'external',
      }}>
      <SpinnerModal show={isLoading} />
      <VStack marginBottom="50%" padding={5} width="100%">
        <ProfileTitle label={`${profile.firstName}, ${profile.lastName}`} />

        <ProfileItem
          label={'profile-item-label-company'}
          value={profile.company}
        />
        <ProfileItem label={'profile-item-label-email'} value={profile.email} />
        <ProfileItem
          label={'profile-item-label-identity'}
          value={profile.identity}
        />
        <VStack marginTop={10}>
          <DangerButton
            label="Eliminar Cuenta"
            onPress={() => handleRemoveAccount()}
          />
        </VStack>
      </VStack>
    </InternalTemplate>
  );
};
export default ProfileScreen;
